import * as Sentry from "@sentry/react";

export const initSentry = (
  dsn: string,
  sampleRate: number,
  release: string,
  environment: string,
  debug: boolean,
) => {
  Sentry.init({
    dsn: dsn || "",
    sampleRate,
    release,
    debug,
    environment,
    tracesSampleRate: 0.0,
    normalizeDepth: 5,
    allowUrls: [
      /webpack-internal:/i,
      /localhost/i,
      /amplifyapp.com/i,

      // Meteo
      /(www\.)?srf\.ch\/meteo/i,
      /www-test\.srf\.ch\/meteo/i,
      /www\.dev\.srf\.ch\/meteo/i,
      /www-stage\.srf\.ch\/meteo/i,
      /www\.int\.srf\.ch\/meteo/i,

      // Landingpage (for mobile app)
      /(www\.)?srf\.ch\/landingpage/i,
      /www-test\.srf\.ch\/landingpage/i,
      /www\.dev\.srf\.ch\/landingpage/i,
      /www-stage\.srf\.ch\/landingpage/i,
      /www\.int\.srf\.ch\/landingpage/i,

      // Meteo RTR
      /(www\.)?rtr\.ch\/aura/i,
      /www-test\.rtr\.ch\/aura/i,
      /www-stage\.rtr\.ch\/aura/i,

      // Landingpage RTR (for mobile app)
      /(www\.)?rtr\.ch\/landingpage/i,
      /www-test\.rtr\.ch\/landingpage/i,
      /www\.dev\.rtr\.ch\/landingpage/i,
      /www-stage\.rtr\.ch\/landingpage/i,
      /www\.int\.rtr\.ch\/landingpage/i,
    ],
    denyUrls: [
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
    ],
    // Use strings for partial matches and regex for exact matches
    // See: https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-
    ignoreErrors: [
      "static.chartbeat.com",
      "kameleoon.eu",
      "googletag",
      "Failed to fetch",
      "Load failed",
      "NetworkError when attempting to fetch resource",
      "Fetch is aborted",
      "AbortError",
      "webtrekk-smart-pixel",
      "Abgebrochen",
      "Identifier 'change_ua' has already been declared",
      "lb",
      "Unexpected token 'else'",
      "The object can not be found here.",
      "SyntaxError: No identifiers allowed directly after numeric literal",
      "Importing a module script failed",
      "error loading dynamically imported module",
      "Can't find variable: gmo",
      "xbrowser is not defined",
      "swbrowser is not defined",
      "No error message",
    ],
    beforeSend: (_event) => {
      // By default, drop all events and do not send anything to Sentry.
      // In case consent is obtained, this hook will be replaced by
      // one that allows events to be sent.
      return null;
    },
  });
};

export const enableOrDisableSentryBasedOnConsent = (
  consentInitialised: boolean,
  consentActive: boolean,
) => {
  if (consentInitialised) {
    if (!Sentry.getClient() || !Sentry.isInitialized()) {
      return;
    }

    if (consentActive) {
      // Consent has been given
      Sentry.getClient()!.getOptions().beforeSend = (event) => {
        // Allow events to be sent
        return event;
      };
    } else {
      // Consent has been denied
      Sentry.getClient()!.getOptions().beforeSend = (_event) => {
        // Drop everything
        return null;
      };
    }
  }
};
